/* app/js/src/components/tenant/tenant-settings.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-list::-webkit-scrollbar,
.main .view .form::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-list::-webkit-scrollbar-button,
.main .view .form::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-list::-webkit-scrollbar-corner,
.main .view .form::-webkit-scrollbar-corner {
  background: transparent;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-list::-webkit-scrollbar-thumb:hover,
.main .view .form::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-list::-webkit-scrollbar-thumb,
.main .view .form::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-list::-webkit-scrollbar-thumb:hover,
.main .view .form::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-list::-webkit-scrollbar-track:hover,
.main .view .form::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-list::-webkit-scrollbar-track,
.main .view .form::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.main .view .form fieldset .ts-form-group .button {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.main .view .form fieldset .ts-form-group .button:focus {
  outline-color: #ffffff;
}
.main .view .form fieldset .ts-form-group .button:hover {
  background-color: white;
  color: #232f3a;
}
.main .view .form fieldset .ts-form-group .disabled.button {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  height: 100%;
}
.header {
  width: 100%;
  height: 45px;
  padding: 15px 15px 15px 20px;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 5%;
  display: flex;
}
.header h1 {
  text-transform: uppercase;
}
.header .buttons {
  display: flex;
  gap: 20px;
}
.header .buttons z > div {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.header .buttons .fill-outlined {
  background: rgb(45, 187, 252);
  border-radius: 4px;
  padding: 9px 16px 9px 16px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  color: rgb(255, 255, 255);
  text-align: center;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
}
.header .buttons .transparent-outlined {
  border-radius: 4px;
  cursor: pointer;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.14);
  border-width: 1px;
  padding: 9px 16px 9px 16px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
}
.main {
  flex-grow: 1;
}
.main .view {
  display: flex;
  padding: 10px;
  gap: 10px;
}
.main .view .categories {
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 5px;
  flex: 0 0 10%;
  height: 50vh;
  min-height: 50vh;
  height: max-content;
  overflow-y: auto;
  padding: 0px 8px;
  margin-top: 9px;
}
.main .view .categories ul {
  padding: 0;
  -webkit-user-select: none;
  user-select: none;
  list-style-type: none;
}
.main .view .categories ul li {
  padding: 8px;
}
.main .view .categories ul li.highlighted {
  background-color: rgba(0, 0, 0, 0.14);
  font-weight: bold;
}
.main .view .categories ul li:hover {
  background-color: rgba(0, 0, 0, 0.14);
}
.main .view .form {
  width: 100%;
  height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.main .view .form fieldset:last-of-type {
  margin-bottom: 20px;
}
.main .view .form fieldset.content-highlighted > legend {
  font-weight: bold;
  transition: all 0.3s ease;
}
.main .view .form fieldset .ts-form-group {
  margin-bottom: 30px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: max-content !important;
  font-size: 12px;
}
.main .view .form fieldset .ts-form-group > div {
  display: inline-flex;
}
.main .view .form fieldset .ts-form-group.content-control-dropdown .ts-action .label {
  width: 300px;
}
.main .view .form fieldset .ts-form-group .button {
  font-size: 11px;
  width: auto;
  height: 30px;
  padding: 6px 17px;
  margin-left: 10px;
}
.main .view .form fieldset .ts-form-group .qc-workflow-list-container .qc-workflow-list {
  min-width: 319px !important;
  width: max-content !important;
}
.main .view .form fieldset .ts-form-group .qc-workflow-list-container .qc-workflow-delete-toggle {
  margin: 0 5px;
}
.main .view .form fieldset .ts-form-group .qc-workflow-list-container .qc-workflow-new-item {
  width: 50% !important;
}
.main .view .form fieldset .ts-form-group .metadata-list-container {
  display: flex;
  flex-direction: column;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-list {
  overflow-y: auto;
  overflow-x: hidden;
  height: 150px;
  width: 319px;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  border: solid 1px #eef2f6;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-item {
  padding: 0 0 0 5px;
  display: flex;
  min-height: 30px;
  align-items: center;
  justify-content: space-between;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-item-name {
  font-family: "Open Sans";
  font-size: 12px;
  color: #232f3a;
  height: min-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 8px;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-item-name[contenteditable] {
  transition: padding 0.2s ease;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-item-name[contenteditable]:focus {
  padding: 8px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: none;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-item-delete-toggle {
  cursor: pointer;
  align-self: center;
  height: min-content;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .metadata-new-item {
  display: flex;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .deleted {
  text-decoration: line-through;
  font-style: italic;
}
.main .view .form fieldset .ts-form-group .metadata-list-container .updated,
.main .view .form fieldset .ts-form-group .metadata-list-container .inserted {
  text-decoration-line: underline;
  text-decoration-style: dotted;
  font-style: italic;
  font-weight: bold;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container {
  padding: 0px 0px 20px 0px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table {
  width: 100%;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-header,
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-header {
  font-weight: bold;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .col-arrow,
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .col-delete {
  width: 36px;
  flex-shrink: 0;
  cursor: pointer;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .col-arrow.expanded svg {
  animation: rotate90 0.1s forwards;
  transform-origin: center;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .col-module {
  width: 240px;
  height: 52px;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .col-type {
  width: 200px;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .col-enabled,
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .col-automatic {
  width: 80px;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .col-action {
  flex-grow: 1;
  min-width: 210px;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .arrow {
  cursor: pointer;
  transition: transform 0.3s ease;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .arrow.expanded {
  transform: rotate(90deg);
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-expanded-row {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-expanded-row.expanded {
  max-height: 605px;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-expanded-row .expanded-content {
  padding: 16px;
  display: flex;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-expanded-row .expanded-content .cc-ai-detection-expanded-row-item {
  display: flex;
  gap: 10px;
  align-items: baseline;
  justify-content: space-around;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-expanded-row .expanded-content .cc-ai-detection-expanded-row-item label {
  width: 170px;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-expanded-row .expanded-content .cc-ai-detection-expanded-row-item mat-form-field {
  width: 80px;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-expanded-row .expanded-content .cc-ai-detection-expanded-row-item .model-url-field {
  width: 800px !important;
}
.main .view .form fieldset .ts-form-group .cc-ai-detection-container .cc-ai-detection-table .cc-ai-detection-expanded-row .expanded-content .cc-ai-detection-expanded-row-item .model-trajectory-field {
  width: 110px !important;
}
.main .view .form fieldset .ts-form-group icn-color-picker {
  margin-right: 1vw;
}
.main .view .form fieldset .ts-form-group .next-show-skip-tags {
  display: flex;
  flex-direction: column;
}
.main .view .form fieldset .ts-form-group .next-show-skip-tags.label {
  white-space: nowrap;
  margin-right: 42px;
}
.main .view .form fieldset .ts-form-group .next-show-skip-tags autocomplete {
  height: 35px;
  width: 1014px;
  padding-right: 33px;
}
.main .view .form fieldset .ts-form-group .next-show-skip-tags tags-wrapper {
  padding-left: 161px;
}
.main .view .form fieldset .ts-form-group .label {
  color: #7d8fa1;
}
.main .view .form fieldset .ts-form-group .ts-info .ts-info-title {
  font-size: 14px;
}
.main .view .form fieldset .ts-form-group .ts-info .ts-info-description {
  margin-bottom: 2px;
}
.main .view .form fieldset .ts-form-group .ts-info .ts-info-note {
  font-style: italic;
}
.main .view .form fieldset .ts-form-group .ts-link {
  color: rgb(45, 187, 252);
  text-align: left;
  font-family: "OpenSans-SemiBold", sans-serif;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  text-decoration: underline;
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.main .view .form fieldset .ts-form-group .ts-link.disabled {
  color: rgba(0, 0, 0, 0.2);
  cursor: not-allowed;
}
.main .view .form fieldset .ts-form-group .ts-action {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 15px;
  margin-left: 0.7vw;
}
.main .view .form fieldset .ts-form-group .ts-action div.checkbox-input {
  flex-basis: 0;
  background-color: #ffffff;
  position: relative;
  margin-top: -3px;
  line-height: 30px;
  display: flex;
  width: 100%;
}
.main .view .form fieldset .ts-form-group .ts-action div.checkbox-input div {
  position: relative;
  border: 1px solid #e1e6eb;
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin-top: 6px;
}
.main .view .form fieldset .ts-form-group .ts-action div.checkbox-input div svg {
  width: 10px;
  height: 7px;
  position: absolute;
  top: -1px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  fill-opacity: 0;
}
.main .view .form fieldset .ts-form-group .ts-action div.checkbox-input.active div svg {
  fill-opacity: 1;
}
.main .view .form fieldset .ts-form-group .ts-action span.label {
  margin-left: 5px;
  flex-basis: 0;
  align-self: center;
  padding-top: 1px;
  white-space: nowrap;
}
.main .view .form fieldset .ts-form-group .ts-action span.label.uppercase {
  text-transform: uppercase;
  position: relative;
  top: -0.5rem;
}
.destinations-settings-nav-platform {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.destinations-settings-nav-platform__icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex-shrink: 0;
}
.destinations-settings-platform-legend {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.destinations-settings-platform-legend__icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
}
.destinations-settings-platform-block .destinations-settings-add-account {
  margin-top: 0.5rem;
}
.destinations-settings-platform-block .destinations-settings-add-account.disabled {
  color: rgba(0, 0, 0, 0.2);
  cursor: not-allowed;
  pointer-events: none;
}
.destinations-settings-tiktok-note {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  max-width: 40rem;
}
.destinations-settings-tiktok-note__help {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  flex: 0 0 1rem;
  border: 1px solid rgba(0, 0, 0, 0.54);
  border-radius: 50%;
  color: rgba(0, 0, 0, 0.54);
  font-family: "Open Sans", sans-serif;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1;
  cursor: help;
  outline: none;
}
.destinations-settings-tiktok-note__help:hover .destinations-settings-tiktok-note__tooltip,
.destinations-settings-tiktok-note__help:focus .destinations-settings-tiktok-note__tooltip {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, -0.25rem);
}
.destinations-settings-tiktok-note__tooltip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 0.5rem);
  z-index: 10;
  width: 24rem;
  max-width: 70vw;
  padding: 0.625rem 0.75rem;
  border-radius: 0.375rem;
  background-color: #232f3a;
  color: rgb(255, 255, 255);
  font-family: "Open Sans", sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.25rem;
  text-align: left;
  white-space: normal;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;
  transform: translate(-50%, 0);
  transition:
    opacity 0.2s ease,
    transform 0.2s ease,
    visibility 0.2s ease;
  pointer-events: none;
}
.destinations-overview-stats {
  margin-top: 0.5rem;
}
.destinations-overview-stats p {
  margin: 0 0 0.375rem 0;
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgba(0, 0, 0, 0.85);
}
.destinations-overview-stats p:last-child {
  margin-bottom: 0;
}
.destinations-accounts-table {
  display: flex !important;
  flex-direction: column;
  width: 100%;
  margin-top: 0.75rem;
}
.destinations-accounts-table__header,
.destinations-accounts-table__row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  min-width: min-content;
}
.destinations-accounts-table .col-arrow {
  width: 2.25rem;
  flex: 0 0 2.25rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.destinations-accounts-table .col-arrow--static {
  cursor: default;
}
.destinations-accounts-table .col-arrow.expanded .arrow {
  transform: rotate(90deg);
}
.destinations-accounts-table .col-arrow .arrow {
  transition: transform 0.2s ease;
}
.destinations-accounts-table__name-cell {
  cursor: pointer;
}
.destinations-accounts-table__expanded-row {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.destinations-accounts-table__expanded-row.expanded {
  max-height: 40rem;
  overflow: visible;
}
.destinations-accounts-table__header {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
}
.destinations-accounts-table__row {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.85);
  overflow: visible;
}
.destinations-accounts-table__row:last-child {
  border-bottom: none;
}
.destinations-accounts-table .col-name {
  flex: 0 0 15rem;
  max-width: 15rem;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  overflow: hidden;
}
.destinations-accounts-table .col-handle {
  flex: 0 0 10rem;
  min-width: 6.25rem;
  max-width: 10rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.destinations-accounts-table .col-status {
  flex: 1 1 auto;
  min-width: 8rem;
  max-width: 14rem;
}
.destinations-accounts-table .col-delete {
  width: 2.25rem;
  flex: 0 0 2.25rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.destinations-accounts-table .col-delete .delete-24-px {
  cursor: pointer;
}
.destinations-accounts-table__status {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.destinations-accounts-table__status.status-cell .destinations-accounts-table__status-icon {
  width: 1.125rem;
  height: 1.125rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.destinations-accounts-table__status.status-cell .destinations-accounts-table__status-icon ::ng-deep svg {
  width: 1.125rem;
  height: 1.125rem;
  display: block;
}
.destinations-accounts-table__status.status--success .destinations-accounts-table__status-icon ::ng-deep path,
.destinations-accounts-table__status.status--success .destinations-accounts-table__status-icon ::ng-deep g {
  fill: #61b965;
}
.destinations-accounts-table__status.status--failed .destinations-accounts-table__status-icon ::ng-deep path,
.destinations-accounts-table__status.status--failed .destinations-accounts-table__status-icon ::ng-deep g {
  fill: #ef5350;
}
.destinations-accounts-table__status.status--warning .destinations-accounts-table__status-icon ::ng-deep path,
.destinations-accounts-table__status.status--warning .destinations-accounts-table__status-icon ::ng-deep g {
  fill: rgb(255, 180, 0);
}
/*# sourceMappingURL=tenant-settings.component.css.map */
